// extracted by mini-css-extract-plugin
export default {"container":"ySdac6XCzZm6TKlJQc9B","badge":"tVsdeIW7q6tJ68T1ApNg","icon":"R8WzHiq6yLnwBXxnalsQ"};